// extracted by mini-css-extract-plugin
export default {"animated":"flappy_animated__g7GHQ","fadeInOut":"flappy_fadeInOut__beiIg","fadeOut":"flappy_fadeOut__Cmnnp","centerText":"flappy_centerText__U1qEf"};